import{ACTION_RESET}from'@virtuous/conductor';import{navigate}from"../../action-creators/router";import{mutable}from"../../helpers/redux";/**
 * @mixes {MutableFunction}
 * @return {Function} The dispatched action.
 */export var historyReset=mutable(function(){return function(dispatch){dispatch(navigate({action:ACTION_RESET}));};});